import React, { Fragment, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import classes from "./Modal.module.css";

const Backdrop = ({ onClick, show }) => {
  return (
    <div
      className={`${classes.background} ${show ? classes.show : classes.hide}`}
      onClick={onClick}
    />
  );
};

const ModalOverlay = ({ children, onClick, show, override_width, buttonText, allowClose }) => {
  return (
    <div className={`${classes.modal} ${show ? classes.show : classes.hide}`}
    style = {{'--override-width' : override_width !== undefined ? override_width : '80%'}}
    >
      <Fragment>{children}</Fragment>
      <button className={classes.btn_main + ' ' + (allowClose ? '' : classes.prevent_close)} onClick={onClick}>
        {buttonText}
      </button>
    </div>
  );
};

const Modal = ({ modalHandler, children,  override_width, allowClose, buttonText  }) => {
  const [show, setShow] = useState(false);
  const [showError, setShowError]  = useState(false)

  useEffect(() => {
    setShow(true);
    const close = (e) => {if (e.keyCode === 27) {handleClose();}};
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, []);

  const handleClose = () => {
    if(allowClose) {
      setShowError(false)
      setShow(false);
      setTimeout(() => {
      modalHandler();
      }, 1000);
    } else {
      setShowError(true)
    }
    
  };

  return (
    <Fragment>
      {ReactDOM.createPortal(
        <ModalOverlay show={show} onClick={handleClose} override_width={override_width} buttonText = {buttonText} allowClose = {allowClose}>
          {children}
          {showError && <p style = {{'color' : 'red'}}> You must acknowledge your agreement before you can proceed </p>}
        </ModalOverlay>,
        document.getElementById("modal-root")
      )}
      {ReactDOM.createPortal(
        <Backdrop show={show} onClick={handleClose} />,
        document.getElementById("backdrop-root")
      )}
    </Fragment>
  );
};

export default Modal;

// import React, { Fragment, useEffect } from "react";
// import ReactDOM from "react-dom";
// import classes from "./Modal.module.css";

// const Backdrop = ({ onClick }) => {
//   return <div className={classes.background} onClick={onClick} />;
// };

// const ModalOverlay = ({ children, onClick }) => {
//   return (
//     <div className={classes.modal}>
//       <Fragment>{children}</Fragment>
//       <button className={classes.btn_main} onClick={onClick}>
//         Close this window
//       </button>
//     </div>
//   );
// };

// const Modal = ({ modalHandler, children }) => {
//   useEffect(() => {
//     const close = (event) => {
//       if (event.keyCode === 27) {
//         modalHandler();
//       }
//     };
//     window.addEventListener("keydown", close);
//     return () => window.removeEventListener("keydown", close);
//   }, [modalHandler]);

//   return (
//     <Fragment>
//       {ReactDOM.createPortal(
//         <ModalOverlay onClick={modalHandler}>{children}</ModalOverlay>,
//         document.getElementById("modal-root")
//       )}
//       {ReactDOM.createPortal(
//         <Backdrop onClick={modalHandler} />,
//         document.getElementById("backdrop-root")
//       )}
//     </Fragment>
//   );
// };

// export default Modal;
